import { render, staticRenderFns } from "./ServicesSwitcherPopup.vue?vue&type=template&id=558eea65&scoped=true&"
import script from "./ServicesSwitcherPopup.vue?vue&type=script&lang=js&"
export * from "./ServicesSwitcherPopup.vue?vue&type=script&lang=js&"
import style0 from "./ServicesSwitcherPopup.vue?vue&type=style&index=0&id=558eea65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558eea65",
  null
  
)

export default component.exports